export default __webpack_public_path__ + "static/media/payment.81532687.png";